import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=4a9634d4"
import script from "./ImageGallery.ts?vue&type=script&lang=ts&external"
export * from "./ImageGallery.ts?vue&type=script&lang=ts&external"
import style0 from "./ImageGallery.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports